import React from "react"
import Select from "react-select"
import { SiteOption } from "../../../types/SiteOption"

interface Props {
    sites: SiteOption[]
    value: SiteOption | null
    onChange: (site: SiteOption | null) => void
    disabled?: boolean
    label?: string
}

export default function SiteSelect({ sites, value, onChange, disabled, label }: Props) {
    return (
        <div className="mb-3" style={{ maxWidth: '500px' }}>
            <label className="text-muted mb-1">
                <small>{label ?? 'Site — laisser vide pour la configuration globale'}</small>
            </label>
            <Select
                isClearable
                options={sites}
                value={value}
                onChange={onChange}
                placeholder="Configuration globale"
                noOptionsMessage={() => "Aucun site trouvé"}
                disabled={disabled}
            />
        </div>
    )
}